import React from 'react'

import { Box, Typography, makeStyles, createStyles } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import LoopIcon from '@material-ui/icons/Loop'
import WarningIcon from '@material-ui/icons/Warning'
import { Alert } from '@material-ui/lab'

export interface AlertAction {
  name: string
  fn?: () => void
}

export enum AlertWithActionsType {
  info = 'info',
  error = 'error',
  warning = 'warning',
  success = 'success',
  loading = 'loading',
}

export interface AlertWithActionsProps {
  type: AlertWithActionsType
  text?: string
  children?: React.ReactNode
  actions: AlertAction[]
  icon?: React.ReactElement
  className?: string
}

const icons = {
  error: <WarningIcon />,
  success: <InfoIcon />,
  warning: <InfoIcon />,
  info: <InfoIcon />,
  loading: <LoopIcon />,
}
const useStyles = makeStyles(() => {
  return createStyles({
    '@global': {
      '@keyframes spinReverse': {
        from: {
          transform: 'rotate(0deg)',
        },
        to: {
          transform: 'rotate(-360deg)',
        },
      },
    },
    iconAlert: {
      '& .MuiSvgIcon-root': {
        animation: ({ type }: AlertWithActionsProps) =>
          type === AlertWithActionsType.loading ? 'spinReverse .8s linear infinite' : null,
      },
    },
  })
})
export default function AlertWithActions({
  type,
  text,
  children,
  actions,
  icon,
  className,
}: AlertWithActionsProps) {
  const { iconAlert } = useStyles({ type })
  const severityType = type !== 'loading' ? type : 'success'
  return (
    <Box display="inline-flex" flexDirection="row">
      <Alert
        severity={severityType}
        icon={icon || icons[type || 'loading']}
        className={`${className} ${iconAlert}`}
      >
        {text || children}
      </Alert>
      {actions.map((action) => (
        <Box ml={6} display="flex" alignItems="center" key={action.name} zIndex="1">
          <Typography onClick={action.fn} className="link">
            {action.name}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

AlertWithActions.defaultProps = {
  actions: [],
}
